import { useEffect, useState } from 'react';

export interface UseTruncationOptions {
  truncate?: boolean | number;
  children: string | React.ReactNode;
}

export const useTruncation = (
  elementRef: React.RefObject<HTMLElement>,
  options: UseTruncationOptions
) => {
  const { truncate, children } = options;
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (truncate && elementRef.current) {
      const element = elementRef.current;

      if (typeof truncate === 'boolean') {
        setIsTruncated(element.offsetWidth < element.scrollWidth);
      } else {
        const computedStyle = getComputedStyle(element);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const fontSize = parseFloat(computedStyle.fontSize);

        const effectiveLineHeight = isNaN(lineHeight)
          ? fontSize * 1.2 // Default line-height multiplier
          : lineHeight;

        const expectedHeight = truncate * effectiveLineHeight;

        setIsTruncated(element.scrollHeight > expectedHeight);
      }
    }

    return undefined;
  }, [truncate, children, elementRef]);

  return isTruncated;
};
